import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { User } from '../models/user.model';
import { FIELDVIEW_API_OAUTH_URL } from '../utils/env';
import { ParcelData } from '../models/fieldview-parcel.model';
import { ParcelBoundary } from '../models/fieldview-boundary.model';

export interface FieldviewUser {
  user: User;
  dealToken: string;
  code: string;
  link: boolean;
}

@Injectable({ providedIn: 'root' })
export class FieldviewService {
  private fieldviewUrl: string = '/fieldview/auth';
  private getFieldsUrl: string = '/fieldview/fields';
  private getFieldBoundaryUrl: string = '/fieldview/boundaries/';

  constructor(private http: HttpClient) {}

  public redirectToFieldviewAuth() {
    window.location.href = FIELDVIEW_API_OAUTH_URL;
  }

  public getFieldviewUser() {
    return this.http.get<any>(this.fieldviewUrl).pipe(map((response) => response.data));
  }

  public deleteFieldviewUser() {
    return this.http.delete(this.fieldviewUrl).pipe(catchError(this.handleError));
  }

  public createFieldviewUser(code: string) {
    return this.http.post(this.fieldviewUrl, code).pipe(catchError(this.handleError));
  }

  public getFieldsUser(pageSize: number, nextToken?: string): Observable<{ data: ParcelData[]; nextToken: string }> {
    // Set up headers
    let headers = new HttpHeaders();
    headers = headers.set('X-Limit', pageSize.toString());
    if (nextToken) {
      headers = headers.set('X-Next-Token', nextToken);
    }
    // Set up options
    const options = { headers: headers, observe: 'response' as const };
    return this.http.get<any>(this.getFieldsUrl, options).pipe(
      map((response: HttpResponse<any>) => {
        // Access the headers
        const responseHeaders = response.headers;

        // Retrieve the value of X-Next-Token ignoring case
        const xNextToken = responseHeaders.get('x-next-token');

        // Parse and return the response data and X-Next-Token
        return { data: response.body.data, nextToken: xNextToken };
      }),
      catchError(this.handleError),
    );
  }

  public getFieldBoundary(boundaryId: string): Observable<ParcelBoundary> {
    return this.http.get<any>(this.getFieldBoundaryUrl + boundaryId).pipe(
      map((response) => {
        const data: ParcelBoundary = response.data;
        return data;
      }),
      catchError(this.handleError),
    );
  }

  private handleError(error: any) {
    console.error('An error occurred', error);
    return throwError(() => error.message || error);
  }
}
